module.exports = __webpack_public_path__ + "img/stock3.cdeb957d.png";